import { DownloadList } from '@vimeo/clip-ui/components/DownloadList';

import { useDownloadVideoFiles } from '../hooks/use-download-video-files';

interface Props {
  onClose: VoidFunction;
  isDownloadModalOpen: boolean;
  clipId?: string | null;
}

export const DownloadListModule = ({ onClose, isDownloadModalOpen, clipId }: Props) => {
  const { videoFiles, isLoading: isLoadingVideoFiles } = useDownloadVideoFiles(clipId ?? null);

  return (
    <DownloadList
      showAsModal
      isOpen={isDownloadModalOpen}
      isLoadingVideoFiles={isLoadingVideoFiles}
      videoFiles={videoFiles}
      texttracks={[]}
      onClose={onClose}
      videoId={clipId ?? undefined}
    />
  );
};
